import React from 'react';
import EmployeeOffers from '../../../../components/EmployeeOffers';
import './Views.scss';

const Views = () => {
    return (
        <div className='panel-container-tab-views'>
            <EmployeeOffers />
        </div>
    );
};

export default Views;
